(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/modules/tickets-einstant/assets/javascripts/components/loader.js') >= 0) return;  svs.modules.push('/modules/tickets-einstant/assets/javascripts/components/loader.js');
"use strict";


const {
  useEffect
} = React;
const Loader = () => {
  useEffect(() => {
    svs.components.loader.show();
    return () => svs.components.loader.hide();
  }, []);
  return null;
};
setGlobal('svs.eInstant.components.Loader', Loader);

 })(window);